import React, { useState } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Actions.module.sass";
import Icon from "../Icon";
import Loader from "../Loader";

const Actions = ({
	className,
	classActionsHead,
	classActionsBody,
	classActionsOption,
	items,
	visible,
	setVisible,
	small,
	up,
}) => {
	const [innerVisible, setInnerVisible] = useState(false);

	const toggle = () => {
		setVisible ? setVisible(!visible) : setInnerVisible(!innerVisible);
	};

	return (
		<OutsideClickHandler
			onOutsideClick={() =>
				setVisible ? setVisible(false) : setInnerVisible(false)
			}
		>
			<div
				className={cn(
					styles.actions,
					className,
					{
						[styles.small]: small,
					},
					{
						[styles.up]: up,
					},
					{
						[styles.active]: visible ? visible : innerVisible,
					}
				)}
			>
				<button
					className={cn(styles.head, classActionsHead)}
					onClick={() => toggle()}
				>
					<Icon name="more-horizontal" size="24" />
				</button>
				<div className={cn(styles.body, classActionsBody)}>
					{items.map((x, index) => {
						const btn = (
							<button
								className={cn(
									styles.option,
									classActionsOption,
									{
										[styles.disabled]: x.isLoading,
									}
								)}
								onClick={x.action}
								key={"ele_" + index}
							>
								{x.isLoading && <Loader />}
								{x.icon && <Icon name={x.icon} size="24" />}
								{x.svgImage && (
									<Icon svgImage={x.svgImage} size="24" />
								)}
								{x.title}
							</button>
						);
						if (x.href) {
							return (
								<a href={x.href} target={x.target ?? undefined}>
									{btn}
								</a>
							);
						} else {
							return btn;
						}
					})}
				</div>
			</div>
		</OutsideClickHandler>
	);
};

export default Actions;
